module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "gaming-background.3bf8d2c3.jpg";